import { getPartnersFileDownloadRanking } from 'api';
import Pagination from 'components/Pagination';
import { defaultPageSizeOptions } from 'constant/Pagination/pageSizeOption';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import useCustomQuery from 'hook/useQuery/useCustomQuery';
import { useEffect, useState } from 'react';
import PartnersFileDownloadRankingTable from './PartnersFileDownloadRankingTable';
import { TableStyle } from './LayoutDefault/styled';

const PartnersFileDownloadRanking = ({
  filterData,
  pageSize,
  countToReset,
  setIsPartnersTableLoading,
  emptyText
}) => {
  const { useQueryAPI } = useCustomQuery();
  const { isOnline, errorNetWork } = useErrorNetworkMessage();

  const [pageNumber, setPageNumber] = useState(1);

  const { data: partnersFileDownloadRankingList = [], isLoading } = useQueryAPI(
    {
      api: getPartnersFileDownloadRanking,
      key: ['getPartnersFileDownloadRankingList', countToReset],
      params: {
        pageNumber,
        pageSize,
        dateFrom: filterData.dateFrom.format('YYYY-MM-DD'),
        dateTo: filterData.dateTo.format('YYYY-MM-DD'),
        filterId: filterData.productId,
      },
    },
  );

  useEffect(() => {
    setPageNumber(1);
  }, [countToReset, pageSize]);

  useEffect(() => {
    setIsPartnersTableLoading(isLoading);
  }, [isLoading]);

  const handleChangePageNumber = (pageNumber) => {
    if (isOnline) {
      setPageNumber(pageNumber);
    } else {
      errorNetWork();
    }
  };

  return (
    <TableStyle>
      <PartnersFileDownloadRankingTable
        dataRaw={partnersFileDownloadRankingList?.data}
        isLoading={isLoading}
        emptyText={isLoading ? '集計中です。' : emptyText}
      />

      <Pagination
        currentPage={pageNumber}
        handlePagingChange={handleChangePageNumber}
        total={partnersFileDownloadRankingList?.data?.total}
        pageSize={pageSize}
        pageSizeOptions={defaultPageSizeOptions}
        isShowTotal={false}
      />
    </TableStyle>
  );
};

export default PartnersFileDownloadRanking;
